import { sortBy, prop } from 'ramda'

export const sortByLabel = sortBy(prop('label'))
